import axiosInstance from "../../../api/axiosInstance";

let putSpace = async(form, id, user) => {
    return new Promise((resolve, reject) => {   
        axiosInstance.put(process.env.REACT_APP_API +"/espacios/update/" + id + "/" + user?.profile + "/" + user?.locale, form)
        .then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export default putSpace